export const useUserInitials = (
  name: string | null,
  surname: string | null,
  nickname: string | null
) =>
  `${name?.split("")[0] || ""}${surname?.split("")[0] || ""}` ||
  nickname?.substring(0, 1) ||
  "";
